import { type FunctionalComponent, h } from '@stencil/core';

export const ConversationalSearchDynamicBannerZeroResult: FunctionalComponent<{
  text: string;
}> = (props) => {
    return (
      <section class="conversational-search-banner-dynamic-zero-result">
        {props.text}
      </section>
    );
};
